<template>
    <div>
        <trax-ui-ajax-simple-table 
            :id="id" :header="header" :header-color="headerColor"
            :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-ajax-simple-table>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-self-paced'},
            header: { default: 0 },
            headerColor: { default: 'primary' },
            facesFolder: {default: app_url},
            facesDefault: {default: 'polaris/img/lib/misc/avatar.jpg'}
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/registrations/'+data.registration.id,
                endpointParams: {
                    accessors: ['members']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners',
                locations_names_id: data.locations_names_id,
                registration: data.registration,
                item: data.item,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                cols: [
                    {width: '50px'},
                    {},
                    {class: 'text-center'}
                ],
                learners : null,
                states : null,
                rows: [],
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.getStates();
        },
        
        methods: {
        
            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.setStates(response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            setData(data) {
                var learners = data.data.members;
                learners.sort(function(a, b) {
                    if (a.lastname < b.lastname) return -1;
                    if (a.lastname > b.lastname) return 1;
                    return 0;
                });
                this.learners = learners;
                if (this.states) this.updateRows();
           },

            setStates(states) {
                this.states = states;
                if (this.learners) this.updateRows();
            },

            updateRows() {
                this.rows = [];
                for (var index in this.learners) {
                    var learner = this.learners[index];
                    this.rows.push([
                        this.picture(learner),
                        this.name(learner),
                        this.state(learner)
                    ]);
                }
            },

            
            //------------------------------- Columns rendering ----------------------------//


            picture(learner) {
                var src = learner.avatar ? learner.avatar : this.facesFolder + this.facesDefault;
                var html = '<img src="'+src+'" class="avatar">'
                return this.link(learner, html);
            }, 

            name(learner) {
                var html = '<span class="font-weight-bold">'+learner.lastname + ' ' + learner.firstname+'</span>';
                var entity = '';
                if (learner.entity) entity = learner.entity.name;
                if (learner.subentity) entity += ' / ' + learner.subentity.name;
                html += '<br><small>'+entity+'</small>';
                return this.link(learner, html);
            },

            state(learner) {
                var state = this.states[learner.id];
                if (!state) return '';
                if (state.learner_validation !== undefined) {
                    var date = state.learner_validation.date;
                    date = moment(date).format('DD MMM YYYY');
                    var html = '<span class="badge badge-success">' + date + '</span>';
                } else {
                    var html = '<span class="badge badge-success">' + this.lang.polaris.dashboard.completed + '</span>';
                }
                return this.link(learner, html);
            },

            link: function(learner, content) {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id+'/learner/' + learner.id;
                return '<a href="'+href+'">'+content+'</a>';
            }
        }

    }
</script>
